<template>
  <v-container class="fill-height" fluid id="login">
    <v-row>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-card class="elevation-12" color="primary">
          <v-form lazy-validation @submit.prevent="onLogin" id="loginForm">
            <v-card-text>
              <span>
                <v-img :src="'/assets/img/' + logo" width="350px"> </v-img>
              </span>
              <v-text-field
                label="Usuário"
                name="login"
                type="text"
                v-model="payload.email"
                :rules="userRules"
                required
                background-color="white"
                solo
              ></v-text-field>

              <v-text-field
                id="password"
                label="Senha"
                name="password"
                type="password"
                v-model="payload.senha"
                :rules="passwordRules"
                required
                background-color="white"
                solo
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col>
                  <div class="text-right">
                    <v-btn text color="accent" :href="'#/auth/lost-password'">
                      Primeiro Acesso | Esqueci minha senha
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-actions>
              <v-row>
                <v-col>
                  <div class="text-center">
                    <v-btn color="secondary" type="submit" id="btnEntrar">
                      Entrar
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Auth from "@/Auth.js";
import { configuracoesAPI } from "@/modules/configuracao";
import { groupsPermissionAPI } from "@/modules/groups";

export default {
  computed: {
    ...mapGetters(["token", "forcedLogout"]),
  },
  data() {
    return {
      payload: {},
      passwordRules: [(v) => !!v || "O campo senha é obrigatório"],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      valid: true,
      expired: Auth.getItem("expired"),
      lastRoute: Auth.getItem("last_route") || null,
      logo: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setConfig",
      "setUser",
      "setIsLogged",
      "setLoading",
      "setAdmin",
      "setGroupsConfig",
      "setConsultor",
      "setAnalista",
      "setAD",
      "setForcedLogout",
      "setFullAdmin",
    ]),
    onLogin() {
      this.setLoading(true);
      this.$http
        .post("api/login", this.payload)
        .then(async ({ data }) => {
          if (data.user) {
            this.setUser(data.user);
            this.setForcedLogout(false);
            if (data.user.email === "admin@admin.com.br")
              this.setFullAdmin(true);
            if (data.user.grupo.nome === "Administrador") this.setAdmin(true);
            else if (data.user.grupo.nome === "Consultor")
              this.setConsultor(true);
            else if (data.user.grupo.nome === "Analista")
              this.setAnalista(true);
            else if (data.user.grupo.nome === "Analista Regional")
              this.setAnalista(true);
            else if (data.user.grupo.nome === "AD") this.setAD(true);
            this.setToken(data.accessToken);

            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.token}`;

            const config = await configuracoesAPI.get();
            const groupPermission = await groupsPermissionAPI.getByGroup(
              data.user.grupo.usuarioGrupoId
            );

            this.setConfig(
              JSON.stringify(
                config.data.filter((item) => item.configuracaoId == 1)[0]
              )
            );

            this.setGroupsConfig(JSON.stringify(groupPermission.data));

            this.$notification.success("Logado com sucesso!", { timer: 10 });
            this.$forceUpdate();
            if (
              this.expired === true &&
              this.forcedLogout === false &&
              this.lastRoute !== "/auth/login"
            ) {
              Auth.setItem("expired", false);
              this.$router.push(this.lastRoute);
            } else this.$router.push("/cidade");
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
          }
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.message) {
            this.$notification.error(err.response.data.message, { timer: 10 });
          } else if (!err.response) {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
            this.setForcedLogout(true);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/auth/login");
            });
          } else {
            this.$notification.error("Credenciais inválidas!", { timer: 10 });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
